module.exports =  {
    isIntitle() {
        if(location.host.indexOf('wuhukj.fun') >= 0){
          return true;
        }
        return false;
    },
}